import { render, staticRenderFns } from "./goodsLocationDatas.vue?vue&type=template&id=1f6f178b&scoped=true&"
import script from "./goodsLocationDatas.vue?vue&type=script&lang=js&"
export * from "./goodsLocationDatas.vue?vue&type=script&lang=js&"
import style0 from "./goodsLocationDatas.vue?vue&type=style&index=0&id=1f6f178b&lang=less&scoped=true&"
import style1 from "./goodsLocationDatas.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f178b",
  null
  
)

component.options.__file = "goodsLocationDatas.vue"
export default component.exports